import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    url: String
  }

  filter(event) {
    const filterValue = event.target.value
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set('task_status_filter', filterValue)

    // Reload the turbo frame
    const turboFrame = this.element.closest('turbo-frame')
    if (turboFrame) {
      turboFrame.src = url.toString()
      turboFrame.reload()
    }
  }
}
